import { ApiResponse } from './../../models/response-api';
import { Projet } from './../../models/projet';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjetService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* create projet */
  createprojet(body: any): Observable<ApiResponse<Projet>> {
    return this._http.post<ApiResponse<Projet>>(
      this._base + '/api/Project/addProject',
      body
    );
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* update projet */
  updateprojet(id: any, projet: any): Observable<ApiResponse<Projet>> {
    return this._http.post<ApiResponse<Projet>>(
      this._base + `/api/Project/update/${id}`,
      projet
    );
  }
  ///////////////////////////////////////////////////////////////
  /* get list projet */

  getListprojet(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    console.log('client iddddddddddddddddd++++++', data, data.id);
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;

    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/Project/getByClientId?id=${data.id}&per_page=${data.per_page}&page=${data.page}${sort}`
    );
  }
  /*recherche projet*/ ////////
  searchprojet(data: any): Observable<ApiResponse<any>> {
    console.log('data', data);

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/Project/searchInListProjects`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////

  getprojets(id: number): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        `${this._base}/api/Project/getByClient?
  id=${id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  supprimer(id: number) {

    return this._http.delete<ApiResponse<any>>(
      this._base + `/api/Project/delete/${id}`,
  
    );
  }
  closeprojet(id: number) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Project/closeProject/${id}`,
      {}
    );
  }


  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /*get projet  by id */
  getProjetById(id: number): Observable<ApiResponse<Projet>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base + `/api/Project/ProjectDetails?id=${id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  /*get membre */
  getmembre(clientFinal_id: number): Observable<ApiResponse<Projet>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/Project/getMembresByClientFinal?clientFinal_id=${clientFinal_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  /*get membre */
  getresponsable(clientFinal_id: number): Observable<ApiResponse<Projet>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/Project/getMembresByClientFinal?clientFinal_id=${clientFinal_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  getlistRoles(company_id: number): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/CompanyRoles/getUsersByRoleName?role_name=responsable&company_id=${company_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  getnouveaumembre(
    clientFinal_id: number,
    project_id: any
  ): Observable<ApiResponse<Projet>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/Project/getUsersForNewMembers?clientFinal_id=${clientFinal_id}&project_id=${project_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  /*get responsable  by id */
  // getresponsable(id: number): Observable<ApiResponse<any>> {
  //   console.log(this._base + `/api/Company/getCompanyWithEmployees/${id}`);
  //   return this._http
  //     .get<ApiResponse<any>>(
  //       this._base + `/api/ConsultantClientFinal/getSalariesConsultantByClientFinal/${id}`
  //     )
  //     .pipe(
  //       map((res: any) => {
  //         if (res) {
  //           console.log(res);
  //           return res;
  //         }
  //       })
  //     );
  // }

  /*get membre  by id project*/
  getmembrebyproject(data: {
    id: number;
    per_page?: number;
    page?: number;
    // sort:number
  }): Observable<ApiResponse<Projet>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/Project/listMembresByProject?id=${data.id}&per_page=${
            data.per_page || 100
          }&page=${data.page || 1}
    
        `
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  // delete membre from project
  deletemembre(id: any): Observable<any> {
    return this._http
      .delete(`${this._base}/api/ProjectCandidate/delete?id=${id}`)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  // delete membre from project
  updateMembre(id: any): Observable<any> {
    return this._http
      .delete(`${this._base}/api/ProjectCandidate/delete?id=${id}`)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
}
